import React, { useState } from 'react';
import { getUser } from '../../utils';
import { Auth } from 'aws-amplify';
import { useHistory } from 'react-router-dom';
import { useSnackbarContext } from '../../contexts/Snackbar';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Container from '@material-ui/core/Container';
import ChangePasswordForm from './ChangePasswordForm';
import Header from '../misc/Header';

const useStyles = makeStyles((theme: any) => ({
  content: { maxWidth: 400, marginTop: theme.spacing(2) },
}));

export default function ChangePasswordSignedIn() {
  const classes = useStyles();
  const snackbar = useSnackbarContext();
  const history = useHistory();
  const [error, setError] = useState();

  return (
    <React.Fragment>
      <Header header="Change password" />
      <Container className={classes.content}>
        <ChangePasswordForm
          onSubmit={async (newPassword, oldPassword) => {
            try {
              const user = await getUser();
              await Auth.changePassword(user, oldPassword, newPassword);
              snackbar.show('Password successfully changed.', 'success');
              setTimeout(() => history.push('/account'), 2000);
            } catch (error) {
              setError(error.message);
            }
          }}
          error={error}
          signedIn={true}
        />
      </Container>
    </React.Fragment>
  );
}
